var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContributors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 19V17C20.5 15.1362 19.2252 13.5701 17.5 13.126M14 1.29076C15.4659 1.88415 16.5 3.32131 16.5 5C16.5 6.67869 15.4659 8.11585 14 8.70924M15.5 19C15.5 17.1362 15.5 16.2044 15.1955 15.4693C14.7895 14.4892 14.0108 13.7105 13.0307 13.3045C12.2956 13 11.3638 13 9.5 13H6.5C4.63623 13 3.70435 13 2.96927 13.3045C1.98915 13.7105 1.21046 14.4892 0.804482 15.4693C0.5 16.2044 0.5 17.1362 0.5 19M12 5C12 7.20914 10.2091 9 8 9C5.79086 9 4 7.20914 4 5C4 2.79086 5.79086 1 8 1C10.2091 1 12 2.79086 12 5Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContributors);
export default __webpack_public_path__ + "static/media/contributors.2a4a159a3561ac504393084e295ad355.svg";
export { ForwardRef as ReactComponent };